import { render, staticRenderFns } from "./PopupEditJuristicPerson.vue?vue&type=template&id=76a1395c"
import script from "./PopupEditJuristicPerson.vue?vue&type=script&lang=ts"
export * from "./PopupEditJuristicPerson.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports